/**
 * Get currency symbol. Always uses the tenant-wide base currency from
 * Settings > Configurations (synced to localStorage on load), regardless of
 * how many branches the logged-in user has. Per-branch currencySymbol is not
 * kept in sync with the tenant's base currency setting, so it must not be
 * used here (previously caused a single-branch user's stale/mis-set branch
 * currency to silently override the correct tenant-wide setting everywhere
 * this helper is used).
 * @returns {string} Currency symbol
 */
export function getCurrencySymbol() {
  try {
    const baseCurrencySymbol = localStorage.getItem('BASE_CURRENCY_SYMBOL');
    if (baseCurrencySymbol) {
      return baseCurrencySymbol;
    }
    return 'KWD'; // Fallback if base currency is not set
  } catch (error) {
    console.error('Error getting currency symbol:', error);
    return 'KWD'; // Fallback
  }
}